import { IFilterSettings } from "Domain/Repository/BaseRepository/BaseRepository";

export const SEARCH_FILE_REFERENCES_REQUEST = 'SEARCH_FILE_REFERENCES_REQUEST';

export const searchFileReferencesRequest = ({
     filter = [],
     sorting = { field: 'id', order: 'ASC' },
     pagination = { page: 1, take: 50 },
 }: IFilterSettings) => ({
    type: SEARCH_FILE_REFERENCES_REQUEST,
    payload: { filter, sorting, pagination },
    meta: {
        sorting,
    }
});
